import React, { useState } from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import { MailOutline } from "@material-ui/icons";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { makeStyles } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";
import { bookingApi } from "functions/apis";
import { toast, ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function AgentBookingAddNotes(props) {
  const submitSignal = new AbortController();
  const [bookingNoteInput, setBookingNoteInput] = useState({
    note: ""
  });
  const [disabled, setDisabled] = React.useState(false);
  const { id } = useParams();

  useEffect(() => {
    return () => submitSignal.abort();
  }, []);

  const handleBookingNoteInputChanged = e =>
    setBookingNoteInput({
      ...bookingNoteInput,
      note: e.target.value === null ? "" : e.target.value
    });

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);

    const resolveFromBookingApi = new Promise((resolve, reject) => {
      bookingApi
        .post(`AgentBookings/${id}/Notes`, bookingNoteInput, {
          signal: submitSignal.signal
        })
        .then(() => {
          resolve({ isSuccess: true });
        })
        .catch(error => {
          reject({ isSuccess: false, error });
        });
    });

    toast
      .promise(resolveFromBookingApi, {
        pending: "...Submitting data",
        success: {
          render({ data }) {
            if (data.isSuccess) {
              return `Success submit data`;
            } else {
              return `Error submit data: ${JSON.stringify(
                data.error?.response.data.title
              )}`;
            }
          }
        },
        error: {
          render({ data }) {
            return `Error submit data: ${JSON.stringify(
              data.error?.response.data.title
            )}`;
          }
        }
      })
      .then(resp => {
        if (resp?.isSuccess) {
          props.history.goBack();
        }
      })
      .finally(() => {
        setDisabled(false);
      });
  };

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>ADD NOTES</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form onSubmit={handleSubmit}>
              <CustomInput
                labelText="Notes"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: handleBookingNoteInputChanged,
                  value:
                    bookingNoteInput.note === null ? "" : bookingNoteInput.note
                }}
              />
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                Submit
              </Button>
            </form>
          </CardBody>
        </Card>
      </GridItem>
      <ToastContainer theme="light" />
    </GridContainer>
  );
}

AgentBookingAddNotes.propTypes = {
  history: PropTypes.object
};
